// extracted by mini-css-extract-plugin
export default {"picker":"DrawingColorPicker_picker__qb7fV","color":"DrawingColorPicker_color__JcRk0"};